import {JSX, Show, splitProps} from "solid-js";
import ZagCheckbox, {ZagCheckboxProps} from "~/components/zag/ZagCheckbox";
import css from "./checkbox.module.css"
import {FaSolidCheck, FaSolidXmark} from "solid-icons/fa";

export interface CheckboxProps extends Omit<ZagCheckboxProps, 'children'> {
    input: (props: any) => JSX.Element;
    label?: JSX.Element;
}

export default function Checkbox(props: CheckboxProps) {

    const [_, zagProps] = splitProps(props, [])

    return (
        <ZagCheckbox {...zagProps}>
            {(api) => (
                <label {...api.getRootProps()} class={css.root}>
                    <Show when={props.label}>
                        <span {...api.getLabelProps()}>{props.label}</span>
                    </Show>
                    <div {...api.getControlProps()} class={css.control}>
                        <Show when={api.checked} fallback={<FaSolidXmark class={css.iconCross}/>}>
                            <FaSolidCheck class={css.iconCheck}/>
                        </Show>
                    </div>
                    <props.input {...api.getHiddenInputProps()}/>
                </label>
            )}
        </ZagCheckbox>
    )
}